// source: imports/content/question_status.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) {
    return this;
  }
  if (typeof window !== 'undefined') {
    return window;
  }
  if (typeof global !== 'undefined') {
    return global;
  }
  if (typeof self !== 'undefined') {
    return self;
  }
  return Function('return this')();
}.call(null));

var imports_options_event_metadata_pb =
    require('../../imports/options/event_metadata_pb.js');
goog.object.extend(proto, imports_options_event_metadata_pb);
goog.exportSymbol('proto.com.chegg.rio.content.QuestionStatus', null, global);
/**
 * @enum {number}
 */
proto.com.chegg.rio.content.QuestionStatus = {
  UNKNOWN_QUESTIONSTATUS: 0,
  NEEDS_MORE_INFO: 1,
  CLOSED: 2,
  ANSWERED: 3,
  NOT_ANSWERED_YET: 4,
  SENT: 5,
  WORKING: 6,
  TOO_MANY_QUESTIONS: 7,
  ABUSIVE: 8,
  UNANSWERED_AND_CLOSED: 9,
  UNDEFINED: 10
};

goog.object.extend(exports, proto.com.chegg.rio.content);



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/rio-event-schema-web/dist/imports/content/question_status_pb.js
// module id = 335
// module chunks = 11